export default __webpack_public_path__ + "static/media/photo--lg--87.504d3796.jpg";